import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { MenuCardLabel, MenuCardLabelSuffix } from "../menu/MenuCardLabel";
import { MenuCard } from "../menu/MenuCard";
import styled from "styled-components";
import { MenuCardScrollContainer } from "../menu/MenuCardScrollContainer";
import { AnimationUploadSubMenu } from "./AnimationUploadSubMenu";
import { MdAnimation } from "react-icons/md";
import { undoableAnimationEditorSelectAnimation } from "../../stores/undo/operation/AnimationEditorSelectionOp";
import { undoableAnimationEditorDeleteAnimation } from "../../stores/undo/operation/AnimationEditorDeletionOp";
import { AdvancedListItem } from "../shared/AdvancedListItem";
import { animationEditorStore } from "../../stores/AnimationSelectionStore";
import { sharedStore } from "../../stores/SharedStore";
import { gameStore } from "../../stores/GameStore";
const ScrollContainer = styled(MenuCardScrollContainer).withConfig({
  displayName: "AnimationListComponent__ScrollContainer",
  componentId: "sc-tee8ia-0"
})(["height:400px;margin-top:4px;width:250px;"]);
const AnimationIcon = styled(MdAnimation).withConfig({
  displayName: "AnimationListComponent__AnimationIcon",
  componentId: "sc-tee8ia-1"
})(["vertical-align:bottom;font-size:20px;margin-right:4px;color:black;"]);
export const AnimationListComponent = observer(() => {
  var _sharedStore$animatio, _sharedStore$animatio2;

  const {
    t
  } = useTranslation();
  const animations = new Array();
  (_sharedStore$animatio = sharedStore.animationAssets) === null || _sharedStore$animatio === void 0 ? void 0 : _sharedStore$animatio.forEach(animationAsset => animations.push(animationAsset));
  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MenuCardLabel, null, t("editor.animation_asset_list_title"), /*#__PURE__*/React.createElement(MenuCardLabelSuffix, null, "(", (_sharedStore$animatio2 = sharedStore.animationAssets) === null || _sharedStore$animatio2 === void 0 ? void 0 : _sharedStore$animatio2.size, ")")), /*#__PURE__*/React.createElement(AnimationUploadSubMenu, null), /*#__PURE__*/React.createElement(ScrollContainer, null, animations.map(animation => {
    var _animationEditorStore;

    return /*#__PURE__*/React.createElement(AdvancedListItem, {
      key: animation.$modelId,
      itemObject: animation,
      itemId: animation.id,
      itemName: animation.localizedName.get(gameStore.languageKey),
      onConfirmDelete: undoableAnimationEditorDeleteAnimation,
      isSelected: ((_animationEditorStore = animationEditorStore.selectedAnimation) === null || _animationEditorStore === void 0 ? void 0 : _animationEditorStore.animation.name) == animation.name || animationEditorStore.currentlyLoadingAnimation == animation.name,
      onSelectItem: item => {
        undoableAnimationEditorSelectAnimation(item, animationEditorStore);
      },
      i18nKeyDeleteModalTitle: "editor.animation_asset_delete_modal_title",
      i18nKeyDeleteModalMessage: "editor.animation_asset_delete_modal_message",
      icon: /*#__PURE__*/React.createElement(AnimationIcon, null),
      allowDeletion: true
    });
  })));
});